const mutations = {
    'SET_BANNERS'(state, { banners }) {
        state.banners = banners
    },
    'SET_DASHBOARD_STATE_COUNTERS'(state, { dashboardStateCounters }) {
        state.dashboardStateCounters = dashboardStateCounters
    },
    'SET_DELIVERY_TIME_STATS'(state, { deliveryTimeStats }) {
        state.deliveryTimeStats = deliveryTimeStats
    },
    'SET_TOP_FREQUENT_CUSTOMERS'(state, { data }) {
        state.topFrequentCustomers = data
    },
    'SET_REPURCHASE_STATS'(state, { repurchaseStats }) {
        state.repurchaseStats = repurchaseStats
    },
    'SET_DELIVERIES_BY_COMMUNE'(state, { deliveriesByCommune }) {
        state.deliveriesByCommune = deliveriesByCommune
    },
    'SET_MONTHLY_DELIVERIES'(state, { monthlyDeliveries }) {
        state.monthlyDeliveries = monthlyDeliveries
    },
    'SET_TOP_STORES_BY_DELIVERIES'(state, { data }) {
        state.topStoresByDeliveries = data
    },
    'SET_DASHBOARD_FILTERS'(state, { filters }) {
        state.dashboardFilters = filters
    }
}
export default mutations
